import { API_GET_NEWS_MORE_SUCCESS, API_GET_NEWS_SUCCESS, } from '../actions/NewsActions';
const initialState = {
    hasMore: false,
    list: [],
    total: 0,
};
// eslint-disable-next-line default-param-last
export default (state = initialState, { payload, total, type }) => {
    switch (type) {
        case API_GET_NEWS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { hasMore: payload.list.length < total, list: payload.list, total });
        }
        case API_GET_NEWS_MORE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { hasMore: payload.list.length < total, list: [...state.list, ...payload.list] });
        }
        default: {
            return state;
        }
    }
};
